import { PropsWithChildren } from "react";
import { TextLink } from "../link/TextLink";
import { navigationLink } from "./style.css";

type NavigationLinkProps = {
  to: string;
  isActive?: boolean;
  isExternal?: boolean;
  onClick?: () => void;
};

export const NavigationLink = ({
  isActive,
  isExternal,
  to,
  onClick,
  children,
}: PropsWithChildren<NavigationLinkProps>) => {
  return (
    <TextLink
      className={isActive ? navigationLink.active : navigationLink.default}
      onClick={onClick}
      to={to}
      isExternal={isExternal}
    >
      {children}
    </TextLink>
  );
};
